export const UC_METHODS_TO_BLOCK = ["showFirstLayer", "showSecondLayer"];

export function isAppWebView() {
	const hasIosBridge = !!window.webkit?.messageHandlers;
	const hasAndroidBridge = !!window.javascriptInterface;
	return hasIosBridge || hasAndroidBridge;
}

export function patchWhenReady() {
	if (window.UC_UI?.isInitialized?.()) {
		stubUcMethods();
		return;
	}
	window.addEventListener("UC_UI_INITIALIZED", stubUcMethods, { once: true });
}

export function stubUcMethods() {
	if (!window.UC_UI) {
		return;
	}
	for (const method of UC_METHODS_TO_BLOCK) {
		if (typeof window.UC_UI[method] === "function") {
			window.UC_UI[method] = blockedInAppWebView;
		}
	}
}

function blockedInAppWebView() {
	// In der App-WebView übernimmt das native Banner den Consent-Flow.
}
